<template>
  <base-container ref="container" :isLoading="loading">
    <base-container style="overflow-y: auto">
      <el-input
        class="margin-v7"
        placeholder="请输入门诊号"
        v-model="clinicNo"
        size="mini"
        @keyup.enter.native="queryCard"
      >
        <template slot="prepend">门诊号</template>
        <el-button
          size="mini"
          slot="append"
          icon="el-icon-search"
          @click="queryCard"
        ></el-button>
      </el-input>
      <div v-if="!cardInfo.status">
        <el-checkbox v-model="cardInfo.obeyAdjustGroup"
          >是否服从调组</el-checkbox
        >
        <el-checkbox v-model="cardInfo.obeyAdjustHos"
          >是否服从调院区</el-checkbox
        >
        <el-input
          class="margin-v5"
          type="textarea"
          :rows="2"
          placeholder="其他"
          v-model="cardInfo.inlineRemark"
          maxlength="100"
          show-word-limit
        >
        </el-input>
        <el-row v-if="isAdmin" type="flex" align="middle" style="margin-bottom: 5px;">
          <span>指定病区：</span>
          <el-select
            style="flex: 1"
            size="mini"
            v-model="cardInfo.reserveWardId"
            filterable
            placeholder="请选择病区"
          >
            <el-option
              v-for="item in wards"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>

        <el-button
          style="width: 100%"
          type="primary"
          icon="el-icon-edit-outline"
          size="mini"
          @click="confirmRigister"
        >
          预约登记
        </el-button>
      </div>
      <RecordDetail phone-editable :record="cardInfo"></RecordDetail>
    </base-container>
  </base-container>
</template>

<script>
import { detail, register } from "@/api/bed/reserve";
import { loadEnum } from "@/api/sys/dicType";
import RecordDetail from "./RecordDetail.vue";
import { isMobile } from "@/util/util";
import { mapGetters } from "vuex";
export default {
  components: {
    RecordDetail,
  },
  props: {
    wardId: String,
  },
  data() {
    return {
      loading: false,
      clinicNo: "",
      cardInfo: {},
      wards: [],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    isAdmin() {
      console.log(this.user);
      return this.user && this.user.roles.find((c) => c.code == "cwAdmin");
    },
  },
  created() {
    if (this.isAdmin) {
      loadEnum("BedWardInfo").then((res) => {
        this.wards = res.data.data;
      });
    }
  },
  methods: {
    queryCard() {
      if (this.clinicNo) {
        this.loading = true;
        this.cardInfo = {};
        detail(this.clinicNo, this.wardId)
          .then((res) => {
            const data = res.data.data;
            if (!data.status) {
              data.obeyAdjust = true;
            }
            this.cardInfo = data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.cardInfo = {};
      }
    },
    confirmRigister() {
      if (!isMobile(this.cardInfo.patientPhone)) {
        this.$message({
          type: "warning",
          message: "请输入正确的手机号！",
        });
        return;
      }
      this.$refs.container.confirm({ msg: "确认要预约登记？" }).then(() => {
        this.loading = true;
        register(this.cardInfo)
          .then(() => {
            this.$message({
              type: "success",
              message: "登记成功！",
            });
            this.clinicNo = "";
            this.cardInfo = {};
            this.loading = false;
            this.$emit("after-register");
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style></style>
